module.exports = __webpack_public_path__ + "img/NoRecordingText1.b094d1d2.svg";